export const adap_datos_recibo = (data) => {

    let obj = {
        valorPagado: data.amount_in_cents / 100,
        fechaPago: new Date(data.finalized_at).getTime(),
        consecutivo: parseInt(data.reference),
        estado: data.status,
        metodo:  data.payment_method && data.payment_method.type ? data.payment_method.type : 'NA' ,
        idTransaccion: data.id
    }

    return obj
}